angular.module('ihestiaCommonDirectives.tryEscapeHtml', [
  'lsnBase.tryEscapeHtml'
]);